// Quiz interactif blog — sans dépendance
(function () {
  'use strict';

  function initQuiz(quiz) {
    var options = quiz.querySelectorAll('.quiz-option, .quiz-btn');
    var results = quiz.querySelectorAll('.quiz-result');

    options.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        var targetId = opt.getAttribute('href').replace('#', '');
        var targetEl = document.getElementById(targetId);

        // Reset
        results.forEach(function (r) { r.classList.remove('is-visible'); });
        options.forEach(function (o) { o.classList.remove('is-active'); });

        // Activate
        if (targetEl) {
          targetEl.classList.add('is-visible');
          opt.classList.add('is-active');
          setTimeout(function () {
            targetEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 60);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.blog-quiz').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
